import styled from "styled-components";

import {
  DefaultParagraphLargeFactory,
  DefaultTitleMediumFactory,
} from "../../../../components/Habitacional/core/Typograph/Typograph.Style";

export const EthicsChannelSectionContainer = styled.section(({ theme }) => ({
  paddingTop: "24px",
  paddingBottom: "40px",
  marginBottom: "0 !important",

  [theme.breakpoint.lg()]: {
    paddingBottom: "60px",
    gap: "40px",
  },
}));

export const EthicsChannelSectionContent = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: "24px",

  button: {
    width: "100%",

    [theme.breakpoint.lg()]: {
      width: "fit-content",
    },
  },
}));

export const EthicsChannelSectionHeader = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
}));

export const EthicsChannelSectionTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleMediumFactory({ theme }),
}));

export const EthicsChannelSectionDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphLargeFactory({ theme }),

  strong: {
    ...DefaultParagraphLargeFactory({ theme }),
    fontWeight: 600,
  },
}));
